import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getLeafChildrenData } from 'timeSheet/utils';
import { TotalTimeWithoutBreaksRenderer } from 'timeSheet/components/CellRenderers';

const useTotalWithoutBreaksColumn = () => {
  const { t } = useContext(ConfigContext);

  const getTotalValue = useCallback((node, fallbackValue) => {
    if (node?.group) {
      const groupItems = getLeafChildrenData(node);
      return groupItems.reduce((sum, item) => sum + (item.actualTotalWithoutBreaks || 0), 0);
    }
    return fallbackValue ?? 0;
  }, []);

  const comparator = useCallback(
    (valueA, valueB, nodeA, nodeB) => {
      const totalA = getTotalValue(nodeA, valueA);
      const totalB = getTotalValue(nodeB, valueB);
      return totalA - totalB;
    },
    [getTotalValue]
  );

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) {
      const groupItems = getLeafChildrenData(params.node);
      return TotalTimeWithoutBreaksRenderer({
        rowData: {
          actualTotalWithoutBreaks: groupItems.reduce((sum, item) => sum + (item.actualTotalWithoutBreaks || 0), 0),
          subRows: groupItems,
          summarized: false
        }
      });
    }

    return TotalTimeWithoutBreaksRenderer({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'actualTotalWithoutBreaks',
      headerName: t('totalTimeWithoutBreaks'),
      width: 100,
      sortable: true,
      comparator,
      cellClass: 'justify-start',
      cellRenderer
    }),
    [t, comparator, cellRenderer]
  );
};

export default useTotalWithoutBreaksColumn;
